"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationUser = void 0;
function makeEmptyQuotationUser() {
    return {
        id: '',
        license: '',
        email: '',
        role: '',
        name: '',
    };
}
exports.makeEmptyQuotationUser = makeEmptyQuotationUser;
//# sourceMappingURL=QuotationUser.js.map